import { get } from "lodash";
import moment from "moment";
import Logo from "../Assets/icons/chat_info.svg";
import Layout from "../Components/Layout";

function View({ onBack, project, translate }) {
  const age = moment().diff(
    moment(get(project, "contact.user.birthDate")),
    "years",
  );
  return (
    <Layout centered>
      <div className="miltis-not-eligible">
        <div className="miltis-not-eligible__content">
          <div className="miltis-not-eligible__header">
            <img
              src={Logo}
              alt="Miltis"
              className="miltis-not-eligible__icon"
            />
            <h1 className="miltis-not-eligible__title">
              {translate?.TITLE || "Merci pour votre demande"}
            </h1>
            <p
              className="miltis-not-eligible__text"
              dangerouslySetInnerHTML={{
                __html:
                  translate?.TEXT || age < 18 || age > 120
                    ? translate?.TEXT_AGE
                    : translate?.TEXT_DEPARTMENT,
              }}
            />
          </div>

          <button
            className="miltis-not-eligible__button"
            onClick={onBack}
            // onClick={() => {
            //   window.location.href = "https://www.mutuelle-miltis.fr/";
            // }}
          >
            <span>
              {translate?.BUTTON?.BACK_TO_HOME || "Revenir à la page d’accueil"}
            </span>
          </button>
        </div>
      </div>
    </Layout>
  );
}

export default View;
